import { Component, OnInit, ChangeDetectionStrategy, Input, OnChanges, SimpleChanges, OnDestroy } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { MatSnackBar } from '@angular/material/snack-bar';
import { of, Subscription, BehaviorSubject } from 'rxjs';
import { catchError, switchMap } from 'rxjs/operators';
import { CustomAlertService } from 'src/app/_components/custom-alert/custom-alert.service';
import { ClassroomService } from 'src/app/_services/classroom.service';

@Component({
  selector: 'app-evento-form-classroom',
  standalone: false,
  templateUrl: './evento-form-classroom.component.html',
  styleUrls: ['./evento-form-classroom.component.scss']
})
export class EventoFormClassroomComponent implements OnInit, OnDestroy {

  @Input()
  evento: any;

  @Input()
  tareas: any[];

  @Input()
  actual;

  @Input()
  materia: any;

  @Input()
  editable: boolean;

  autorizado: boolean;

  classroomSelectForm = new UntypedFormGroup({
    classroomSelect: new UntypedFormControl(0)
  });

  savingSubject = new BehaviorSubject(true);
  notSaving$ = this.savingSubject.asObservable();

  valueChangesSubscription: Subscription;
  cambiosClassroomSubscription: Subscription;

  tareasCambios: any[];

  constructor(
    private classroomService: ClassroomService,
    private customAlertService: CustomAlertService,
    private snackBar: MatSnackBar
    ) { }

  ngOnInit(): void {
    this.autorizado = true;
    if (this.materia) {
      this.tareasCambios = this.tareas.filter(item => this.materia.classroomCourseId === item.courseId);
    } else {
      this.tareasCambios = this.tareas;
    }
    this.actual = this.actual || 0;
    this.classroomSelectForm.setValue({classroomSelect: this.actual});
    this.evento.courseWork = this.tareasCambios.find(item => item.id === this.actual);
    // Logica para determinar si es autorizado.
    if (this.evento.courseWork) {

    } else {
      if (this.actual !== 0) {
        this.autorizado = false;
      }
    }
    this.valueChangesSubscription = this.classroomSelectForm.get('classroomSelect').valueChanges.pipe(
      switchMap(data => {
        this.savingSubject.next(false);
        const accion = +data !== 0;
        return this.enlazarRequest(accion, data);
      })
    ).subscribe(res => {
      this.savingSubject.next(true);
      if (res) {
        // this.snackBar.open( +res.courseWorkId === 0 ? 'La evidencia ha sido desenlazada exitosamente.'
        //   : 'La evidencia ha sido enlazada exitosamente.', null, {duration: 2500});
        this.actual = res.courseWorkId;
        this.evento.courseWork = this.tareasCambios.find(item => +item.id === +this.evento.courseWorkId);
      }
    });

    this.cambiosClassroomSubscription = this.classroomService.cambios$.subscribe(res => {
      if (this.materia && res && res.accion === 'materia-update') {
        const materia = res.obj.find(item => (item.materiaCursoPeriodoId || item.id) === this.materia.id);
        if (materia) {
          // this.materia = materia;
          this.tareasCambios = this.tareas.filter(item => item.courseId === materia.classroomCourseId);
          if (materia.classroomCourseId !== 0) {
            this.classroomService.getClassroomCourswork(materia.classroomCourseId).pipe(
              catchError(err => {
                return [];
              })
            ).subscribe(res => {
              this.tareasCambios = res;
            });
          } else {
            this.evento.courseWork = null;
            this.tareasCambios = [];
          }

          this.classroomSelectForm.reset();
          this.evento.courseWork = this.tareasCambios.find(item => item.id === this.actual);
        }
      }
      if (res && res.accion === 'evento-update') {
        if (this.evento.id === res.obj.id) {
          if (res.obj.courseWorkId === 0) {
            this.classroomSelectForm.setValue({classroomSelect: 0}, {emitEvent: false});
          }
          this.evento = res.obj;
          this.evento.courseWork = this.tareasCambios.find(item => +item.id === +this.evento.courseWorkId);
        }
      }
    });
  }

  enlazarRequest(accion, data) {
    const actual = this.actual;
    return this.classroomService.enlazarClassroomTarea(
      this.evento, accion, accion ? this.tareas.find(item => item.id === data) : null).pipe(
        catchError(err => {
          this.savingSubject.next(true);
          this.classroomSelectForm.setValue({classroomSelect: actual}, {emitEvent: false});
          this.customAlertService.setCustomMessage({
            tipo: 'error',
            texto: `No ha sido posible realizar la acción. <br> Código de error: ${err.statusText}`
          });
          return of(false);
        })
      );
  }

  desEnlazar() {
    this.savingSubject.next(false);
    this.enlazarRequest(false, null).subscribe(
      res => {
        this.savingSubject.next(true);
        if (res) {
          this.snackBar.open( +res.classroomCourseId === 0 ? 'La materia ha sido desenlazada exitosamente.'
            : 'La materia ha sido enlazada exitosamente.', null, {duration: 2500});
          this.actual = res.classroomCourseId;
          this.savingSubject.next(true);
        }
      }
    );
  }

  ngOnDestroy(): void {
    this.valueChangesSubscription.unsubscribe();
    this.cambiosClassroomSubscription.unsubscribe();
  }

}
